import styled from "styled-components";

export const Select = styled.select`
  background-color: ${({ theme }) => theme.darkestBlue};
  border: 1px solid ${({ theme }) => theme.secondaryBlue};
  outline: none;
  padding: ${({ theme }) => `${theme.doublePadding} ${theme.oneSixthPadding}`};
  border-radius: ${({ theme }) => theme.borderRadius};
  color: ${({ theme }) => theme.bodyColor};
  font-family: ${({ theme }) => theme.fontFamily};
  width: 100%;
  box-sizing: border-box;

  /* hide native arrow */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  /* custom arrow with the same right padding as left */
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'><path d='M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z'/></svg>");
  background-repeat: no-repeat;
  background-position: right ${({ theme }) => theme.doublePadding} center;
  background-size: 1rem;

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ::placeholder {
    color: ${({ theme }) => theme.grey};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${({ theme }) => theme.grey};
  }

  ::-ms-input-placeholder {
    color: ${({ theme }) => theme.grey};
  }
`;
